import { useChangeFilterValue, useFilterValue } from '@btime/react-contexts'
import React from 'react'
import { useTranslation } from 'react-i18next'

import ChecklistTypePicker from '../picker/ChecklistTypePicker'

const ChecklistTypesFilter = ({ field, ...props }) => {
  const { t } = useTranslation('checklistTypes')
  field = field || 'checklistTypeIds'
  const label = t('checklistType')
  const value = useFilterValue(field, [])
  const handleChange = useChangeFilterValue()

  return (
    <div>
      <ChecklistTypePicker value={value} onChange={handleChange(field)} multiple label={label} {...props} />
    </div>
  )
}

export default ChecklistTypesFilter
